let isinnerDrawerCall = false;
class cartDrawer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        this.note = null;
        this.discount = null;
        this.debounceTimer = null;
        this.abortController = null;
        this.colordebounceTimer = null;
        document.querySelector('[cart-drawer-open]')?.addEventListener('click',(event)=>{
            this.openDrawer(event);
        });
        document.addEventListener('cart:item-added', (event) => {
            this.addToCartTrigger(event);
        });
      
        this.addEventListener('click',(event)=>{
            if(event.target.closest('[item-minus]')) this.quantityUpdate(event,'minus');
            if(event.target.closest('[item-plus]')) this.quantityUpdate(event,'plus');
            if(event.target.closest('[item-remove]')) this.lineUpdate(event,0);
            if(event.target.closest('[data-swap-buttons]')) this.swapActiveBtn(event);
            // if(event.target.closest('[cart-drawer-open]')) this.openDrawer(event);
            if(event.target.closest('[cart-drawer-close]')) this.closeDrawer(event);
            if(event.target.closest('[cart-drawer-note]')) this.noteToggle(event);
            if(event.target.closest('[cart-drawer-shipping]')) this.noteToggle(event);
            if(event.target.closest('[cartdrawer-close-note]')) this.noteToggle(event);
            if(event.target.closest('[cartdrawer-close-shipping]')) this.noteToggle(event);
            if(event.target.closest('[cartdrawer-save-note]')) this.updateNote(event);
            if(event.target.closest('[cartdrawer-calculate-shipping]')) this.calculateShipping(event);
            if(event.target.closest('[cart-drawer-discount]')) this.applyDiscount(event);
            if(event.target.closest('[swatch-selected]')) this.changeCartVariant(event);
        });
        this.addEventListener('focusout',(event)=>{
            if(event.target.closest('[item-input]')) this.quantityValidate(event);
        });
        this.loading = (state) =>{
            state ? this.classList.add('loading') : this.classList.remove('loading');
        }
    }
    quantityUpdate(event,action){
        const lineItem = event.target.closest('[item-line]');
        const input = lineItem.querySelector('[item-input]');
        if(action == 'minus'){
            Number(input.value) > Number(input.min) ? input.stepDown() : 0;
        } else {
            input.stepUp()
        }
        this.lineUpdate(event,input.value);
    }
    quantityValidate(event){
        const lineItem = event.target.closest('[item-line]');
        const input = event.target.closest('[item-input]');
        const isTrueVal = input.value.match(/^[0-9]+$/) ? true : false;
        if(isTrueVal)this.lineUpdate(event,input.value);
    }
    async lineUpdate(event,quantity){
        const lineItem = event.target.closest('[item-line]');
        const line = Number(lineItem.dataset.line);
        const lineQuantity = Number(quantity);
        const lineData = {
            line,'quantity':lineQuantity
        }
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
            if(this.abortController){
                this.abortController.abort();
            }
            this.abortController = new AbortController();
            this.loading(true);
            await fetch('/cart/change.js',{
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({...lineData,sections:"cart-icon-bubble,cart-drawer"}),
                signal: this.abortController.signal
            })
            .then((response)=> response.json())
            .then((cartJson) => this.updateDrawer(cartJson))
            .catch((error) => {if (error.name === 'AbortError') return;console.error(error);});
            this.loading(false);
        }, 300);
    }
    async updateDrawer(cartJson){
        const items_count = cartJson.items.length;
        this.querySelector('.cart_drawer').setAttribute('class',`cart_drawer items_${items_count}`)
        let newcartsection = "";
        for(let i in cartJson.sections){
            newcartsection += cartJson.sections[i]
        }
        const newHtml = await new DOMParser().parseFromString(newcartsection,'text/html');
        const updateSelector = ['.cart_link_cnt','.cart_drawer_header','.cart_items','.free_shipping_txt','.cart_footer'];
        for(let i of updateSelector){
            const n = newHtml.querySelector(i);
            if(n){
                document.querySelectorAll(i).forEach(element => {
                    element.parentNode.replaceChild(n,element);
                });
            }
        }
        const prgressBar = newHtml.querySelector('.shipping_process')
        if(prgressBar) document.querySelectorAll('.shipping_process').forEach(element => element.setAttribute('style',prgressBar.getAttribute('style')));
        if(countryAndRegionSlector)countryAndRegionSlector();
        this.note = cartJson?.note;
    }
    openDrawer(event){
        document.querySelectorAll('[data-modal-close]')?.forEach((elem)=>elem.dispatchEvent(new MouseEvent('click',{bubbles:true})));
        if(event) event.preventDefault();
        document.body.classList.add('overflow-hidden');
        this.classList.add('active');
    }
    closeDrawer(event){
        if(event) event.preventDefault();
        document.body.classList.remove('overflow-hidden');
        this.classList.remove('active');
    }
    swapActiveBtn(event){
        if(event.target.closest('button').classList.contains('active')) return;
        this.querySelectorAll('[data-swap-buttons] button').forEach(element => element.classList.toggle('active'));
        if(this.querySelector('.cart_items_offer_slider')) this.querySelector('.cart_items_offer_slider')?.classList.toggle('active');
    }
    noteToggle(event){
        const btn = event.target.closest('button');
        const cartFooter = btn.closest('[cart-drawer-footer]');
        if(cartFooter && btn?.dataset?.name){
            btn.dataset.name == 'note' ? cartFooter.classList.remove('shipping'): cartFooter.classList.remove('note');
            cartFooter.classList.toggle(btn.dataset.name);
        }
    }
    async updateNote(event){
        const note = this.querySelector('#order-note')?.value;
        if(this.note != note){
            this.loading(true);
            await fetch('/cart/update.js',{
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body: JSON.stringify({note})
            })
            .then((resonse) => resonse.json())
            .then((cartJson) => {this.note = cartJson.note;this.noteToggle(event);})
            .catch((error) => {console.error(error)});
            this.loading(false);
        }
    }
    async calculateShipping(event){
        const calBtn = event.target.closest('button');
        const massaageHTMl = this.querySelector('.shipping_massage');
        const countrySelect = this.querySelector('#CountrySelect');
        const stateSelect = this.querySelector('#ProvinceSelect');
        const zipinput = this.querySelector('#Zip');

            const shipping_address = `?shipping_address[zip]=${zipinput.value}&shipping_address[country]=${countrySelect.value}&shipping_address[province]=${stateSelect.value}`;
            this.loading(true);
            await fetch('/cart/shipping_rates.json'+encodeURI(shipping_address), {
                method: 'POST',
                headers: {'Content-Type':'application/json'},
            })
            .then((response) => response.json())
            .then((shippingJson) => {
                massaageHTMl.innerHTML = '';
                if(shippingJson.shipping_rates){
                    for(let shippment of shippingJson.shipping_rates){
                        if(shippment.presentment_name){
                           const presentment_name =  document.createElement('p');
                           presentment_name.textContent = `${shippment.presentment_name}: `
                            massaageHTMl.append(presentment_name);
                        }
                        if(shippment.price){
                           const price =  document.createElement('p');
                           price.textContent = `shipping charge for selected region is ${calBtn.dataset.currency.slice(0, calBtn.dataset.currency.indexOf('0.00'))}${shippment.price}`
                            massaageHTMl.append(price);
                        }
                    }
                }
                if(shippingJson.country){
                   const country =  document.createElement('p');
                   country.textContent = `${shippingJson.country[0]}`
                   massaageHTMl.append(country);
                }
                if(shippingJson.province){
                   const province =  document.createElement('p');
                   province.textContent = `${shippingJson.province[0]}`
                    massaageHTMl.append(province);
                }
                if(shippingJson.zip){
                   const zip =  document.createElement('p');
                   zip.textContent = `${shippingJson.zip[0]}`
                    massaageHTMl.append(zip);
                }
                if(!shippingJson.shipping_rates.length){
                   const zip =  document.createElement('p');
                   zip.textContent = `No Shipping carrier found for selected region.`
                    massaageHTMl.append(zip);
                }
            })
            .catch((error) => console.error(error));
            this.loading(false);

    }
    async applyDiscount(event){
        const discountIn = document.querySelector('#DiscountCart');
        if(discountIn.value){
            const discount = this.discount ? this.discount+`,${discountIn.value}` : discountIn.value;
            this.loading(true);
            await fetch('/cart/update.js',{
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({discount,sections:"cart-icon-bubble,cart-drawer"}),
            })
            .then((response) => response.json())
            .then((cartJson) => {
                this.updateDrawer(cartJson);
                this.checkDiscountapplication(cartJson);
            })
            .catch((error) => console.error(error));
            this.loading(false);
            if(this.querySelector('.discount_success')){
                this.querySelector('.discount_success').classList.remove('hidden');
                setTimeout(() => {
                    this.querySelector('.discount_success').classList.add('hidden');
                }, 2500);
            }
        }
    }
    checkDiscountapplication(cartJson){
        const discounts = [];
        if(cartJson.discount_codes){
            for(let code of cartJson.discount_codes){
                if(code?.applicable) discounts.push(code.code)
            }
        }
        if(discounts.length) this.discount = discounts.join(',');
    }
    async addToCartTrigger(event){
            this.loading(true);
            await fetch('/cart/update.js',{
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({sections:"cart-icon-bubble,cart-drawer"})
            })
            .then((response)=> response.json())
            .then((cartJson) => {this.openDrawer(event);this.updateDrawer(cartJson);})
            .catch((error) => console.error(error));
            this.loading(false);
    }
    async changeCartVariant(event){
        const colorVariant = event.target.closest('[swatch-selected]');
        const currentVariant = colorVariant.getAttribute('swatch-selected');
        const selectedVariant = colorVariant.querySelector('input:checked')?.dataset.variantId;
        const line = Number(event.target.closest('[item-line]')?.dataset?.line);
        const quantity = Number(event.target.closest('[item-line]')?.querySelector('.quantity_input').value);
        clearTimeout(this.colordebounceTimer);

        this.colordebounceTimer = setTimeout(async () => {     
            if(this.colorabortController){
            }
            console.log(Number(currentVariant), Number(selectedVariant))
                const lineData = {
                    line,'quantity':0
                }
                this.loading(true);
                await fetch('/cart/change.js',{
                    method: 'POST',
                    headers: {'Content-Type':'application/json'},
                    body: JSON.stringify({...lineData,sections:"cart-icon-bubble,cart-drawer"}),
                })
                .then((response) => response.json())
                .then(async (cartJson) => {
                    let formData = {
                        'items': [{
                        'id': Number(selectedVariant),
                        'quantity': quantity
                        }],
                        'sections':"cart-icon-bubble,cart-drawer"
                    };
                    isinnerDrawerCall = true;
                    await fetch('/cart/add.js',{
                        method: 'POST',
                        headers: {'Content-Type':'application/json'},
                        body: JSON.stringify(formData)
                    })
                    .then((response) => response.json())
                    .then(async (cartJsonnew) => {this.updateDrawer(cartJsonnew)})
                    .catch((error) => {if (error.name === 'AbortError') return;console.error(error);});
                })
                .catch((error) => {if (error.name === 'AbortError') return;console.error(error);});
                this.loading(false);
        },300);
    }
}
customElements.define("cart-drawer", cartDrawer);

document.addEventListener('DOMContentLoaded', countryAndRegionSlector());
  function countryAndRegionSlector() {
    var countrySelect = document.getElementById('CountrySelect');
    var provinceSelect = document.getElementById('ProvinceSelect');

    function updateProvinces() {
      var selectedOption = countrySelect.options[countrySelect.selectedIndex];
      var provincesData = selectedOption.getAttribute('data-provinces');

      provinceSelect.innerHTML = '';

      if (!provincesData) {
        provinceSelect.disabled = true;
        return;
      }

      var provinces = JSON.parse(provincesData); 

      if (provinces.length === 0) {
        provinceSelect.disabled = true;
        var placeholder = document.createElement('option');
        placeholder.textContent = 'No States / Region';
        placeholder.value = '';
        provinceSelect.appendChild(placeholder);
        return;
      }

      provinceSelect.disabled = false;

      var placeholder = document.createElement('option');
      placeholder.textContent = 'Select States / Region';
      placeholder.value = '';
      provinceSelect.appendChild(placeholder);

      provinces.forEach(function (province) {
        var option = document.createElement('option');
        option.value = province[0]; 
        option.textContent = province[1];
        provinceSelect.appendChild(option);
      });
    }

    countrySelect.addEventListener('change', updateProvinces);
    updateProvinces();
  }

  (function () {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (typeof url === 'string' && url.includes('/cart/add')) {
      if (response.ok) {

        const cloned = response.clone();
        cloned.json().then((data) => {
            if(!isinnerDrawerCall){
                document.dispatchEvent(
                    new CustomEvent('cart:item-added', { detail: data })
                );
            } else{
                isinnerDrawerCall = false;
            }
        });
      }
    }

    return response;
  };
})();